import React from 'react';
import makeCls from "../../../app/editor/utils/makeCls";

export default React.forwardRef(function GridItem({children, className, grow, ...props}, ref) {
    return (
        <div ref={ref} className={makeCls([className, grow && 'flex-1'])} {...props}>
            {children}
        </div>
    );
});
